import script from "./IndicatorsStatisticInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./IndicatorsStatisticInfo.vue?vue&type=script&setup=true&lang=ts"

import "./IndicatorsStatisticInfo.vue?vue&type=style&index=0&id=708b9b6c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-708b9b6c"]])

export default __exports__